<template>
  <div class="node-bar-container">
    <div class="tabWrapper">
      <div class="tab"><span class="pointer fa fa-cog" style="margin-right: 6px"></span>作业组件</div>
    </div>
    <div id="panelContainer" class="tabContentWrapper">
      <a-collapse v-model="activeKey" accordion>
        <a-collapse-panel key="1" header="基础组件">
          <ul class="nodes-bar">
            <li v-for="(node, index) in nodes" :key="index">
              <div
                :class="[freeze ? `freeze-${node.shape}` : `default-${node.shape}`]"
                :style="node.styles"
                @mousedown="startDrag(node, $event)"
              >
                <span>{{ node.label }}</span>
              </div>
            </li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="数据采集组件">
          <ul class="nodes-bar">
            <li v-for="(node, index) in datacollectNodes" :key="index">
              <div
                :class="[freeze ? `freeze-${node.shape}` : `default-${node.shape}`]"
                :style="node.styles"
                @mousedown="startDrag(node, $event)"
              >
                <img src="@/assets/run.svg" style="width:18px;position: absolute;top:14px;left:8px;"/>
                <span style="position: absolute;left:36px;">{{ node.label }}</span>
              </div>
            </li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel key="3" header="数据加工组件">
          <ul class="nodes-bar">
            <li v-for="(node, index) in datajobNodes" :key="index">
              <div
                :class="[freeze ? `freeze-${node.shape}` : `default-${node.shape}`]"
                :style="node.styles"
                @mousedown="startDrag(node, $event)"
              >
                <img src="@/assets/run.svg" style="width:18px;position: absolute;top:14px;left:8px;"/>
                <span style="position: absolute;left:36px;">{{ node.label }}</span>
              </div>
            </li>
          </ul>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>
<script>
import { Addon } from "@antv/x6";
import { Channel } from "../common/transmit";
import { ActionType, CustomEventTypeEnum } from "../common/enums";
import {
  getDiamondNode,
  getEllipseNode,
  getRectNode,
  getDatJobNode,
} from "../common/transform";

export default {
  props: ["nodes", "datajobNodes", "datacollectNodes", "graph"],
  data() {
    return {
      dnd: {},
      freeze: false,
      activeKey: '2'
    };
  },
  watch: {
    graph() {
      this.initDnd();
    },
  },
  methods: {
    startDrag(currentTarget, e) {
      const { actionType, shape, label, jobType, jobCode } = currentTarget;
      const { TRIGGER, CONDITION, ACTION, DATA_JOB, DATA_COLLECT } = ActionType;
      let json;
      switch (actionType) {
        // 触发器
        case TRIGGER:
          json = getEllipseNode({
            shape,
            tooltip: label,
            size: { width: 100, height: 50 },
            actionType,
            initialization: true,
          });
          break;
        // 条件
        case CONDITION:
          json = getDiamondNode({
            // x6 不存在 diamond 形状, 转义 rect
            shape: "rect",
            tooltip: label,
            actionType,
            initialization: true,
          });
          break;
        // 动作
        case ACTION:
          json = getRectNode({
            shape,
            tooltip: label,
            size: { width: 100, height: 50 },
            actionType,
            initialization: true,
          });
          break;
        // 数据采集作业
        case DATA_COLLECT:
          json = getDatJobNode({
            shape,
            tooltip: label,
            size: { width: 200, height: 48 },
            actionType,
            initialization: true,
            jobType: jobType,
            jobCode: jobCode,
          });
        // 数据加工作业
        case DATA_JOB:
          json = getDatJobNode({
            shape,
            tooltip: label,
            size: { width: 200, height: 48 },
            actionType,
            initialization: true,
            jobType: jobType,
            jobCode: jobCode,
          });
          break;
        default:
          break;
      }
      const node = this.graph.createNode(json);
      if (!this.freeze) this.dnd.start(node, e);
    },
    initDnd() {
      this.dnd = new Addon.Dnd({
        target: this.graph,
        validateNode() {
          return true;
        },
      });
    },
  },
  created() {
    // 冻结工具栏
    Channel.eventListener(CustomEventTypeEnum.FREEZE_GRAPH, (bool) => {
      this.freeze = bool;
    });
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/index.scss";
@include mixin_scrollbar;
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.node-bar-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabWrapper {
    align-items: center;
    height: 40px!important;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    .tab {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: center;
      height: 36px;
      padding: 0 8px;
      text-align: center;
      font-size: 14px;
      font-variant: tabular-nums;
      font-feature-settings: 'tnum';
      
      cursor: pointer;

      &:first-of-type {
        border-right: 1px solid #f0f0f0;
      }

      &:hover {
        color: #1890ff;
      }

      &.active {
        color: #1890ff;
        background-color: #f7f9fb;
        cursor: default;
      }
    }
  }

  .tabContentWrapper {
    // 禁止被双击选中
    user-select: none;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    .nodes-bar {
      width: 100%;
      height: 300px;
      padding: 20px 0;
      overflow: auto;
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #303133;
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
        }

        [class^="default-"] {
          transition: all 0.08s;
          &:hover {
            transform: scale(1.1) !important;
            color: #333;
          }
        }

        // 默认菱形
        .default-diamond {
          &:hover {
            transform: rotateZ(45deg) scale(1.1) !important;
          }
          span {
            transform: rotate(-45deg);
          }
        }

        [class^="freeze-"] {
          opacity: 0.7;
          cursor: no-drop;
        }
        .freeze-diamond {
          &:hover {
            transform: rotateZ(45deg) scale(1) !important;
          }
          span {
            transform: rotate(-45deg);
          }
        }
      }
    }
  }

  #panelContainer :global(.ant-collapse-content-box) {
    padding: 0;
  }
}

</style>
